module.exports = __webpack_public_path__ + "img/2976.03deedff.png";